export const getRelicRarity = (relic) =>
  relic?.rarity === 'mythic' ||
  relic?.rarity === 'rare' ||
  relic?.rarity === 'uncommon'
    ? relic.rarity
    : 'common';

export const formatRelicRarity = (rarity) =>
  rarity === 'mythic'
    ? 'Mythic'
    : rarity === 'rare'
    ? 'Rare'
    : rarity === 'uncommon'
    ? 'Uncommon'
    : 'Common';

export const rollRelicRarity = (rng, weights) => {
  const wC = Number(weights?.common ?? 0.7);
  const wU = Number(weights?.uncommon ?? 0.25);
  const wR = Number(weights?.rare ?? 0.05);
  const wM = Number(weights?.mythic ?? 0);

  const total = Math.max(0.000001, wC + wU + wR + wM);
  const x = (typeof rng === 'function' ? rng() : Math.random()) * total;

  if (x < wC) return 'common';
  if (x < wC + wU) return 'uncommon';
  if (x < wC + wU + wR) return 'rare';
  return 'mythic';
};

export const pickRelicsByRarity = (eligible, count, rng, weights) => {
  const pool = Array.isArray(eligible) ? eligible.filter(Boolean) : [];
  const used = new Set();
  const by = { common: [], uncommon: [], rare: [], mythic: [] };

  for (const r of pool) {
    if (!r?.id || used.has(r.id)) continue;
    by[getRelicRarity(r)].push(r);
  }

  const pickOne = (arr) => {
    if (!arr.length) return null;
    const idx = Math.floor(
      (typeof rng === 'function' ? rng() : Math.random()) * arr.length
    );
    return arr[idx] || null;
  };

  const picks = [];
  for (let i = 0; i < count; i++) {
    const wanted = rollRelicRarity(rng, weights);

    const order =
      wanted === 'common'
        ? ['common', 'uncommon', 'rare', 'mythic']
        : wanted === 'uncommon'
        ? ['uncommon', 'common', 'rare', 'mythic']
        : wanted === 'rare'
        ? ['rare', 'uncommon', 'common', 'mythic']
        : ['mythic', 'rare', 'uncommon', 'common'];

    let chosen = null;
    for (const key of order) {
      const candidates = by[key].filter((r) => r?.id && !used.has(r.id));
      chosen = pickOne(candidates);
      if (chosen) break;
    }

    if (!chosen) {
      const any = pool.filter((r) => r?.id && !used.has(r.id));
      chosen = pickOne(any);
    }

    if (!chosen?.id) break;
    used.add(chosen.id);
    picks.push(chosen);
  }

  return picks;
};